// From https://github.com/camsong/fetch-jsonp
var defaultOptions = {
  timeout: 5000,
  jsonpCallback: 'callback'
};

function generateCallbackFunction() {
  return "jsonp_" + Date.now() + "_" + Math.ceil(Math.random() * 100000);
} // Known issue: Will throw 'Uncaught ReferenceError: callback_*** is not defined' error if request timeout


function clearFunction(functionName) {
  // IE8 throws an exception when you try to delete a property on window
  // http://stackoverflow.com/a/1824228/751089
  try {
    delete window[functionName];
  } catch (e) {
    window[functionName] = undefined;
  }
}

function removeScript(script) {
  document.getElementsByTagName('head')[0].removeChild(script);
}

function addScript(script) {
  document.getElementsByTagName('head')[0].appendChild(script);
}

var JSONP = function (url, options) {
  if (options === void 0) {
    options = {};
  }

  return new Promise(function (resolve, reject) {
    var _options = options,
        timeout = _options.timeout,
        jsonpCallback = _options.jsonpCallback,
        callbackFunction = _options.callbackFunction;

    if (!timeout) {
      timeout = defaultOptions.timeout;
    }

    if (!jsonpCallback) {
      jsonpCallback = defaultOptions.jsonpCallback;
    }

    if (!callbackFunction) {
      callbackFunction = generateCallbackFunction();
    }

    var timeoutId;
    var jsonpScript = document.createElement('script');

    window[callbackFunction] = function (response) {
      resolve({
        ok: true,
        json: function json() {
          return Promise.resolve(response);
        }
      });
      if (timeoutId) clearTimeout(timeoutId);
      removeScript(jsonpScript);
      clearFunction(callbackFunction);
    };

    url += url.indexOf('?') === -1 ? '?' : '&';
    jsonpScript.setAttribute('src', "" + url + jsonpCallback + "=" + callbackFunction);
    addScript(jsonpScript);
    timeoutId = setTimeout(function () {
      clearTimeout(timeoutId);
      reject(new Error("JSONP request to " + url + " timed out"));
      clearFunction(callbackFunction);
      removeScript(jsonpScript);
    }, timeout);
  });
};

export default JSONP;